/**
 * One column the metadata type cannot express: `public` is a boolean the product calls Visibility, so it
 * reads Public/Private. Every other column keeps the framework renderer.
 */
import { JobTemplate, MetadataEntityData, MetadataEntityFieldData } from '@jms/model';
import type { EntityBoardColumnOverrides, EntityBoardContext } from '@workbuddy/ui/v2/blocks/entity.board/context';
import { BooleanCellParams, BooleanCellRenderer } from '@workbuddy/ui/cell.renderers';

export const jobTemplateColumnOverrides: EntityBoardColumnOverrides<JobTemplate> = {
  byField: {
    // `name` is the metadata's `identifier`, so the framework width-locks it at min === max and it
    // could not resize. No `flex`: the view makes `name` a fixed (pinned) column, and AG Grid only
    // flexes centre columns — the blank spacer absorbs the leftover width instead.
    name: { width: 320, minWidth: 120, maxWidth: undefined },
  },
};

export function overrideJobTemplateCellRenderer(_context: EntityBoardContext<JobTemplate>, _metadata: MetadataEntityData, field: MetadataEntityFieldData, renderer: unknown): unknown {

  if ((field.path as keyof JobTemplate) === 'public') {
    return { cellRenderer: BooleanCellRenderer, cellRendererParams: { format: 'Public/Private' } satisfies Partial<BooleanCellParams> };
  }

  return renderer;
}
